import {
  getLotteryChildData,
  createLotteryOrder,
  getOddsData,
  getNewLotteryRes,
  getLongQueue,
  getStatistics, getLhShengXiao
} from "../../../service/lottery";
import { createHistoryKey } from "../../../utils/computed";

export const state = {
  page: "gd_ha10",

  // 投注记录
  order_history: {},

  // 当前选中玩法
  curTab: 0,

  // 子玩法规则
  tabs: [],

  lottery: {
    latest_result: {},
    next_info: {}
  },

  // 赔率，10秒刷新
  odds: [],
  // 生肖号码，10秒刷新
  shengxiaoData: [],

  longQueue: [],
  statistics: [],
  lhOddsPlayedName: '', // 六合odds子玩法
};

export const actions = {
  // 更改缓存played_name
  async setPlayedName({commit}, played_name) {
    commit("SET_LH_PLAYED_NAME", played_name);
  },
  // 获取当前玩法赔率
  async getCurOddsData(
    {commit, rootState},
    {category_id, sub_category_id, lottery_type, played_name}
  ) {
    // 方法会轮询，如果数据存在就不再请求了
    if (rootState.home_PK10.shengxiaoData.length === 0) {
      const lhInfo = await getLhShengXiao();
      if (lhInfo.result === "ok") {
        commit("SET_LH_SHENGXIAO", lhInfo.data);
      }
    }
    const info = await getOddsData({
      category_id,
      sub_category_id,
      lottery_type,
      played_name
    });
    if (info.result === "ok") {
      commit("SET_LH_PLAYED_NAME", played_name);
      commit("SET_ODDS_INFO", info.data);
    }
  },
  // 创建订单，并加入投注记录
  async createOrder({state, dispatch, commit}, data) {
    const info = await createLotteryOrder({
      ...data,
      data: data.list
    });
    // 投注失败
    if (info.result !== "ok") return info.msg;

    // 投注成功，将投注记录添加到本地列表
    const key = createHistoryKey(data);
    const order_history = {...state.order_history};
    // 投注记录
    if (!order_history[key]) order_history[key] = [];

    // 如果存在原始列表
    data.list = data.origin_list || data.list;

    order_history[key].push(data);

    // 添加到投注记录
    commit("SET_ORDER_HISTORY", order_history);

    /**
     * 更新个人余额
     * 更新投注记录
     * */
    await Promise.all([
      dispatch("home/getLotteryLatest", {}, {root: true}),
      dispatch("root/updateUserInfo", {}, {root: true})
    ]);
  },

  // 获取子玩法数据
  async getTabsData({commit}, id) {
    const info = await getLotteryChildData(id);
    if (info.result === "ok") {
      commit("SET_CHILD_TAB", info.data);
    }
  },

  // 获取当前开奖结果
  async getNewLotteryRes({commit, state}, {sub_category_id,lottery_type}) {
    const info = await getNewLotteryRes({sub_category_id,lottery_type});
    if (info.result === "ok") {
      commit("SET_LOTTERY_DATA", info.data);
    }
  },

  // 获取长龙
  async getLongQueue({commit, state}, {lottery_type}) {
    const info = await getLongQueue(lottery_type);
    if (info.result === "ok") {
      commit("SET_LONGQUEUE_DATA", info.data);
    }
  },

  // 开奖统计
  async getStatistics({commit, state}, {lottery_type}) {
    const info = await getStatistics(lottery_type);
    if (info.result === "ok") {
      commit("SET_STATISTICS_DATA", info.data);
    }
  }
};

export const mutations = {
  // 重置关键数据
  ["RESET_DATA"](state) {
    state.lottery.next_info.draw_time = "2000-08-21 23:02:18";
    state.odds = [];
  },
  ["SET_LOTTERY_DATA"](state, lottery) {
    state.lottery = lottery;
  },
  ["SET_CHILD_TAB"](state, tabs) {
    state.tabs = tabs;
  },
  ["SET_CUR_TAB"](state, curTab) {
    state.curTab = curTab;
  },
  ["SET_ODDS_INFO"](state, info) {
    state.odds = info;
  },
  ["SET_ORDER_HISTORY"](state, order_history) {
    state.order_history = order_history;
  },
  ["SET_LONGQUEUE_DATA"](state, longQueue) {
    state.longQueue = longQueue;
  },
  ["SET_STATISTICS_DATA"](state, statistics) {
    state.statistics = statistics;
  },
  ["SET_LH_SHENGXIAO"](state, value) {
    state.shengxiaoData = value;
  },
  ["SET_LH_PLAYED_NAME"](state, value) {
    state.lhOddsPlayedName = value;
  }
};

export const getters = {};



// WEBPACK FOOTER //
// ./src/pages/home/gd_ha10/store.js